import * as tslib_1 from "tslib";
import _ from 'lodash';
import dayjs from 'dayjs';
import { GetExpirationsUrl, GetStrikesUrl, GetChainUrl } from '../constants';
import { formatExpiration } from '../utilities/DateUtilities';
import { DateFormats } from '..';
export const getExpirations = (api) => {
    return (symbol) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const res = yield api.get(GetExpirationsUrl, {
            underlyingSymbol: symbol,
            isExpanded: 'true',
        });
        const expDates = _.map(res.payload ? res.payload : [], d => (Object.assign({}, d, formatExpiration(d))));
        return {
            responseCode: res.responseCode,
            payload: expDates,
        };
    });
};
export const getStrikes = (api) => {
    return (symbol, expiration, time, strikeMin, strikeMax) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const expirations = yield api.get(GetStrikesUrl, {
            underlyingSymbol: symbol,
            expiration: dayjs(expiration).format(DateFormats.ApiFormat),
            strikeMin,
            strikeMax,
            time,
        });
        return expirations;
    });
};
export const getChain = (api) => {
    return (symbol, expiration, strikeCount, fetchGreeks) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        // if strike count == 0, fetch all strikes
        const underlyingSymbol = symbol;
        const strikeParams = strikeCount === 0 ? {} : { strikesAroundMarket: strikeCount / 2 };
        const chainData = yield api.get(GetChainUrl, Object.assign({ underlyingSymbol, expiration: dayjs(expiration).format(DateFormats.ApiFormat), // pass date part only without time
            fetchGreeks }, strikeParams));
        const chainDataResults = _(chainData.payload).reduce((pairs, expirations, opsymbol) => {
            const expirationStrikes = _(expirations)
                .flatMap(exp => _.flatMap(exp))
                .map(e => (Object.assign({}, e, { symbol: opsymbol, underlyingSymbol })))
                .value();
            return _.union(pairs, expirationStrikes);
        }, []);
        return { data: _.sortBy(chainDataResults, op => op.Strike), responseCode: chainData.responseCode };
    });
};
export const options = (api) => ({
    expirations: getExpirations(api),
    strikes: getStrikes(api),
    optionchain: getChain(api),
});
//# sourceMappingURL=options.js.map